mutation RestoreAudience($id: ID!) {
    audienceRestore(input: {id: $id}) {
        audience {
            id
        }
    }
}
